import { FC, useEffect } from 'react';
import { useAppContext } from '@/context/AppContext';
import BeatPanel from './components/BeatPanel/BeatPanel';
import StartStopButton from './components/StartStopButton/StartStopButton';
import './Clock.css';
import Stack from '@/shared/components/Stack/Stack';

const Clock: FC = () => {
  const { clock, startClock } = useAppContext();

  // Initialize clock when component mounts
  useEffect(() => {
    if (!clock) {
      startClock();
    }
  }, [clock, startClock]);

  if (!clock) {
    return null;
  }

  return (
    <Stack direction="horizontal" gap="md" className="clock">
        <StartStopButton />
        <BeatPanel />
    </Stack>
  );
};

export default Clock;
